const Avatar = (props) => {
    return (
      <img className="user-pfp shadow" src={"https://cdn.discordapp.com/avatars/" + props.id + "/" + props.avatar} alt="pfp" />
    );
}

export default Avatar;